<template>
  <div>
    <div
      class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage"
    >
      <!-- <HeaderNew></HeaderNew> -->
      <div class="container-fluid maindivWrap pt-4">
        <div class="row">
          <div class="col-12">
            <div class="row mx-0">

              <div class="col-12 px-0">
                <div class="row mx-0">
                      <div class="col-4 px-0">

                          <form>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="fa fa-search" aria-hidden="true"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search..."
                              id
                              name
                              v-model="searchName"
                              style="border-left:0;"
                            />
                          </div>
                        </form>
                      </div>
                      <div class="col-8 px-0">
                        <div class="d-flex" style="justify-content: flex-end;">
                          <div class="mx-2">
                            <form class="form-inline" action="/action_page.php">
                              <label for="" class="mr-sm-2">Show:</label>
                              <select class="form-control" id="sel1" v-model="perPage">
                                <option>10</option>
                                <option>50</option>
                                <option>100</option>
                                <option>500</option>
                              </select>
                            </form>
                          </div>
                        </div>
                      </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="listingTable mb-4">
              <div class="row mx-0">
                <div class="col-12 px-0">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="section_title mt-3">Indicator</h5>
                    </div>
                    <div class="col-6">
                      <!-- <a href="#indicatorAdd" -->
                      <a href="javascript:void(0)"
                        class="btn btn-sm float-right addTemp_btn mt-3 mr-0"
                        @click = "showForm();"
                      >
                        <span class="border_bottom_grey" >
                          <i class="fa fa-plus" aria-hidden="true"></i> Add Indicator
                        </span>
                      </a>
                    </div>
                  </div>
                  <div class="card tableCard">
                    <div class="card-body px-0 pt-2">
                      <table
                        class="table table-striped table-hover mb-0 bg-white" style="border-radius: 10px;     box-shadow: 0px 0px 2px #ddd;"
                      >
                        <thead>
                          <tr class="row mx-0" style="border-radius: 10px 10px 0 0;">
                            <th class="col-1" style="border-top: 0;">No.</th>
                            <th class="col-6" style="border-top: 0;">
                              Indicator Name
                            </th>

                            <th class="col-3" style="border-top: 0;">
                              Updated On
                            </th>
                            <th class="col-2" style="border-top: 0;">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="indicator,ind in allIndList1">
                            <tr class="row mx-0">
                              <td class="col-1">{{ind +1}}.</td>
                              <td class="col-6">{{indicator.displayName}}</td>

                              <td class="col-3">{{indicator.lastUpdated}}</td>
                              <td class="col-2">
                                <div class="iconGroup">
                                  <a href="#indicatorAdd" @click="editind(indicator.id)">
                                    <i class="fa fa-pencil-square-o cursor-pointer"
                                      aria-hidden="true"
                                      v-b-tooltip.hover
                                      title="Edit"
                                    ></i>
                                  </a>

                                  <i
                                    class="fa fa-trash cursor-pointer"
                                    aria-hidden="true"
                                    v-b-tooltip.hover
                                    title="Delete"  @click="deleteind(indicator.id)"
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="mt-3" v-if="allIndList1.length > 0">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="allIndLen"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    align="center"

                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12" v-if="showIndForm" ref="indicatorAdd">
            <div class="wizardCard mb-4 " >
              <div class="card shadow-sm">
                <div class="card-header">
                  Add Indicator
                </div>
                <div class="card-body">
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorName"
                          class="col-sm-3 col-form-label"
                          >Indicator Name</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            id="indicatorName"
                            placeholder v-model="frmModel.name"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Description</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            id="indicatorTypeName"
                            placeholder v-model="frmModel.shortName"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Indicator Type</label
                        >
                        <div class="col-sm-9">
                          <div class="dropdown">
                            <!-- <button
                              type="button"
                              class="btn btn-newprimary btn-block dropdown-toggle addIndicatorTypebtn"
                              data-toggle="dropdown"
                            >
                              Add Indicator Type
                            </button> -->
                            <!-- <select class="dropdown-menu w-100" v-model="frmModel.indicatorType"> -->
                              <b-select
                              :options="indicatorTypeList"
                              v-model="indicatorType"
                              >
                            </b-select>
                              <!-- <a class="dropdown-item" href="#">Link 1</a>
                              <a class="dropdown-item" href="#">Link 2</a>
                              <a class="dropdown-item" href="#">Link 3</a> -->
                            <!-- </select> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Decimals in data output</label
                        >
                        <div class="col-sm-9">
                          <b-select
                            :options="decimalOptions"
                            v-model="frmModel.decimals"
                            >
                          </b-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-12 col-form-label card-header mx-1 mb-0" style="padding: 15px 14px !important; border-radius: 8px 8px 0 0 !important;"
                          >Add Numerator / Denominator</label
                        >
                        <div class="col-sm-12">
                          <div class="tabsSelection">
                            <b-tabs pills card>
                              <b-tab title="Numerator" active
                                ><b-card-text>
                                  <div class="">
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">
                                          <label
                                            for="numeratorDescription"
                                            class="col-sm-2 col-form-label"
                                            >Description</label
                                          >
                                          <div class="col-sm-10">
                                            <input
                                              type="text"
                                              class="form-control"
                                              id="numeratorDescription"
                                              placeholder v-model="frmModel.numeratorDescription"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">
                                          <div class="col-sm-12">
                                            <div id="accordion">
                                              <div class="card rounded-0">
                                                <div
                                                  class=""
                                                  id="headingOne"
                                                  data-toggle="collapse"
                                                  data-target="#collapseOne"
                                                  aria-expanded="true"
                                                  aria-controls="collapseOne"
                                                >
                                                  <h5 class="mb-0">
                                                    <button
                                                      class="btn btn-light btn-block text-left bg_f4" style="border: 1px solid #ddd;"
                                                    >
                                                      Data Element
                                                    </button>
                                                  </h5>
                                                </div>

                                                <div
                                                  id="collapseOne"
                                                  class="collapse show"
                                                  aria-labelledby="headingOne"
                                                  data-parent="#accordion"
                                                >
                                                  <div
                                                    class="card-body pt-1 pb-0 px-0 rounded-0"
                                                  >
                                                    <div class="row">
                                                      <div class="col-sm-5">
                                                        <div class="row">
                                                          <div class="col-12 pr-0">
                                                            <div class="py-3 px-2" style="border-right:1px solid #ddd;">
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('(','(')"
                                                                >(</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem(')',')')"
                                                                >)</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('*','*')"
                                                                >*</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('/','/')"
                                                                >/</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('+','+')"
                                                                >+</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('-','-')"
                                                                >-</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-2 mx-1" @click="addElem('[Days]','[Days]')"
                                                                >Days</b-badge
                                                              >
                                                            </div>
                                                          </div>
                                                          <div class="col-12 pr-0">
                                                            <div class="p-3 " style="border-top:1px solid #ddd; border-right:1px solid #ddd;" >
                                                              <textarea class="expressionBuilder form-control" v-model="expressionBuilderHidden">
                                                              </textarea>
                                                              <div class="alertSection mt-3">
                                                                <b-alert show variant="success" v-if="expressionbuilderstatuscheck">Expression is <b>Valid</b><br/><br/> <b>{{expressionBuilder}} </b></b-alert>
                                                                <b-alert show variant="danger" v-else-if="expressionBuilderHidden != '' && expressionbuilderstatuscheck == false">Expression is <b>not well-formed </b></b-alert>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-sm-7">
                                                        <div
                                                          class="swipTextWrap"
                                                        >
                                                          <div class="form-group has-search mt-3 w-100">
                                                            <span class="fa fa-search form-control-feedback"></span>
                                                            <input type="text" class="form-control" placeholder="Search" v-model="serachoptionslist">
                                                          </div>
                                                          <select
                                                            multiple   class="form-control multiSelectOption border border-0 mb-2 px-0" >
                                                            <template v-for="elem,i in dataElementList">
                                                            <option :value="elem.id" @click="addElem(elem.id,elem.displayName,'DataElem')">
                                                              {{elem.displayName}}
                                                            </option>
                                                          </template>
                                                          </select>

                                                          </select>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-card-text></b-tab
                              >
                              <b-tab title="Denominator"
                                ><b-card-text
                                  >
                                    <div class="">
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">
                                          <label
                                            for="denominatorDescription"
                                            class="col-sm-2 col-form-label"
                                            >Description</label
                                          >
                                          <div class="col-sm-10">
                                            <input
                                              type="text"
                                              class="form-control"
                                              id="denominatorDescription"
                                              placeholder v-model="frmModel.denominatorDescription"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">

                                          <div class="col-sm-12">
                                            <div id="accordion">
                                              <div class="card rounded-0">
                                                <div
                                                  class=""
                                                  id="headingOne"
                                                  data-toggle="collapse"
                                                  data-target="#collapseOne"
                                                  aria-expanded="true"
                                                  aria-controls="collapseOne"
                                                >
                                                  <h5 class="mb-0">
                                                    <button
                                                      class="btn btn-light btn-block text-left bg_f4" style="border: 1px solid #ddd;"
                                                    >
                                                      Data Element
                                                    </button>
                                                  </h5>
                                                </div>

                                                <div
                                                  id="collapseOne"
                                                  class="collapse show"
                                                  aria-labelledby="headingOne"
                                                  data-parent="#accordion"
                                                >
                                                  <div
                                                    class="card-body pt-1 pb-0 px-0 rounded-0"
                                                  >
                                                    <div class="row">
                                                      <div class="col-sm-5">
                                                        <div class="row">
                                                          <div class="col-12 pr-0">
                                                            <div class="py-3 px-2" style="border-right:1px solid #ddd;">
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('(','(')"
                                                                >(</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom(')',')')"
                                                                >)</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('*','*')"
                                                                >*</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('/','/')"
                                                                >/</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('+','+')"
                                                                >+</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('-','-')"
                                                                >-</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-2 mx-1" @click="addElemDenom('[Days]','[Days]')"
                                                                >Days</b-badge
                                                              >
                                                            </div>
                                                          </div>
                                                          <div class="col-12 pr-0">
                                                            <div class="p-3" style="border-top:1px solid #ddd; border-right:1px solid #ddd;">
                                                              <textarea class="expressionBuilder form-control" v-model="denomExpressionBuilderHidden">
                                                              </textarea>
                                                              <div class="alertSection mt-3">

                                                                <b-alert show variant="success" v-if="denomexpressionbuilderstatuscheck">Expression is <b>Valid</b> <b>{{denomExpressionBuilder}}</b></b-alert>
                                                                <b-alert show variant="danger" v-else-if="denomExpressionBuilderHidden != '' && denomexpressionbuilderstatuscheck == false">Expression is <b>not well-formed</b></b-alert>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-sm-7">
                                                        <div
                                                          class="swipTextWrap"
                                                        >
                                                        <div class="form-group has-search mt-3 w-100">
                                                            <span class="fa fa-search form-control-feedback"></span>
                                                            <input type="text" class="form-control" placeholder="Search" v-model="serachoptionslist1">
                                                          </div>
                                                        <select
                                                          multiple   class="form-control multiSelectOption border border-0 mb-2 px-0" >
                                                          <template v-for="elem,i in denomdataElemenList">
                                                          <option :value="elem.id" @click="addElemDenom(elem.id,elem.displayName,'DataElem')">
                                                            {{elem.displayName}}
                                                          </option>
                                                        </template>
                                                        </select>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  </b-card-text
                                ></b-tab
                              >
                            </b-tabs>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="bottomSubmitbtn float-right mb-4">
              <button class="btn btn-newprimary" @click="resetForm">
                Cancel
                <!-- <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i> -->
              </button>
              <button class="btn btn-newprimary" @click="updateInd" v-if="frmModel.id">
                Update
                <!-- <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i> -->
              </button>
              <button class="btn btn-newprimary" @click="submitInd" v-else>
                Save
                <!-- <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i> -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <training-footer></training-footer> -->
  </div>
</template>
<script>
import HeaderNew from "../components/layout/HeaderNew";
import trainingFooter from "../components/trainingFooter";
import ApiServices from "../service/ApiServices";
import swal from "sweetalert2";
window.Swal = swal;

export default {
  components: {
    HeaderNew,
    trainingFooter,
  },
  data() {
    return {
      showIndForm: false,
      userProfile: "",
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      options: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "5", text: "5" },
        { value: "25", text: "25" },
        { value: "50", text: "50" },
        { value: "100", text: "100" },
      ],
      decimalOptions: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
      ],
      perPage: 10,
      serachoptionslist: "",
      currentPage: 1,
      allAppsList: [],
      allIndList: [],
      searchName: "",
      denomSearchName: "",
      isView: "list",
      allAppsListLen: 0,
      dataElementList: [],
      denomdataElemenList: [],
      indicatorTypes: [],
      indicatorType: "",
      expressionBuilder: "",
      serachoptionslist1: "",
      expressionBuilderHidden: "",
      denomExpressionBuilder: "",
      expressionbuilderstatuscheck: false,
      denomexpressionbuilderstatuscheck: false,
      //  indicatorTypeList:[],
      denomExpressionBuilderHidden: "",
      frmModel: {
        denominatorDescription: "",
        numeratorDescription: "",
        numerator: "",
        denominator: "",
        name: "",
        shortName: "",
        indicatorType: {},
        legendSets: [],
      },
    };
  },
  computed: {
    indicatorTypeList: function () {
      let typeArr = this.indicatorTypes;

      var arr = [];
      var obj = { value: "", text: "Select Indicator Type" };
      arr.push(obj);
      typeArr.forEach((type, ind) => {
        var obj = { value: "", text: "" };
        obj.value = type.id;
        obj.text = type.displayName;
        arr.push(obj);
      });
      // console.log(arr);
      return arr;
    },
    allIndList1() {
      let filteredInd = this.allIndList.filter(
        (a) =>
          (a.displayName &&
            a.displayName
              .toLowerCase()
              .includes(this.searchName.toLowerCase())) ||
          // (a.createdBy &&
          //   a.createdBy
          //     .toLowerCase()
          //     .includes(this.searchName.toLowerCase())) ||
          (a.lastUpdated &&
            a.lastUpdated.toLowerCase().includes(this.searchName.toLowerCase()))
      );
      this.allIndLen = filteredInd.length;
      // console.log(filteredInd);
      return filteredInd.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    // appsList() {
    //   let filteredApps = this.allAppsList.filter(
    //     (a) =>
    //       (a.appName &&
    //         a.appName.toLowerCase().includes(this.searchName.toLowerCase())) ||
    //       (a.createdBy &&
    //         a.createdBy
    //           .toLowerCase()
    //           .includes(this.searchName.toLowerCase())) ||
    //       (a.updatedBy &&
    //         a.updatedBy.toLowerCase().includes(this.searchName.toLowerCase()))
    //   );
    //   // console.log("filteredApps",filteredApps)
    //   this.allAppsListLen = filteredApps.length;
    //   return filteredApps.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    rows() {
      return this.allAppsList.length;
    },
  },
  watch: {
    expressionBuilderHidden(newVal) {
      // console.log("Call api", newVal);
      if (newVal != "") {
        ApiServices.RestPostCall(
          "api/indicators/expression/description",
          newVal,
          "text/plain"
        ).then((res) => {
          // console.log(res);
          if (res.status == "OK") {
            this.expressionbuilderstatuscheck = true;
            this.expressionBuilder = res.description;
          } else {
            this.expressionbuilderstatuscheck = false;
            this.expressionBuilder = "";
          }
        });
      } else {
        this.expressionBuilder = "";
        this.expressionbuilderstatuscheck = false;
      }
    },
    // denomExpressionBuilder(newv,oldval) {
    //   if (newv == "") this.denomExpressionBuilderHidden = newv;
    // },
    denomExpressionBuilderHidden(newVal) {
      // console.log("Call denom api", newVal);
      if (newVal != "") {
        ApiServices.RestPostCall(
          "api/indicators/expression/description",
          newVal,
          "text/plain"
        ).then((res) => {
          // console.log(res);
          if (res.status == "OK") {
            this.denomexpressionbuilderstatuscheck = true;
            this.denomExpressionBuilder = res.description;
          } else {
            this.denomexpressionbuilderstatuscheck = false;
            this.denomExpressionBuilder = "";
          }
        });
      } else {
        this.denomExpressionBuilder = "";
        this.denomexpressionbuilderstatuscheck = false;
      }
    },

    serachoptionslist(newavl) {
      // console.log(newavl);
      ApiServices.RestGetCall(
        "api/29/dataElementOperands?filter=dataElement.domainType:eq:AGGREGATE&filter=name:ilike:" +
          newavl +
          "&fields=id%2CdisplayName&totals=true",
        {}
      ).then((res) => {
        // console.log(res);
        if (res.dataElementOperands != undefined)
          this.dataElementList = res.dataElementOperands;
      });
    },
    serachoptionslist1(newval) {
      // console.log(newval);
      ApiServices.RestGetCall(
        "api/29/dataElementOperands?filter=dataElement.domainType:eq:AGGREGATE&filter=name:ilike:" +
          newval +
          "&fields=id%2CdisplayName&totals=true",
        {}
      ).then((res) => {
        // console.log(res);
        if (res.dataElementOperands != undefined)
          this.denomdataElemenList = res.dataElementOperands;
      });
    },
  },
  methods: {
    resetForm() {
      this.showIndForm = false;
      this.frmModel = {
        denominatorDescription: "",
        numeratorDescription: "",
        numerator: "",
        denominator: "",
        name: "",
        shortName: "",
        indicatorType: {},
        legendSets: [],
      };
      this.expressionBuilderHidden = "";
      this.denomExpressionBuilderHidden = "";
      this.expressionBuilder = "";
      this.denomExpressionBuilder = "";
      this.indicatorType = "";
    },
    showForm() {
      this.showIndForm = true;
      this.frmModel = {
        denominatorDescription: "",
        numeratorDescription: "",
        numerator: "",
        denominator: "",
        name: "",
        shortName: "",
        indicatorType: {},
        legendSets: [],
      };
      this.expressionBuilderHidden = "";
      this.denomExpressionBuilderHidden = "";
      this.expressionBuilder = "";
      this.denomExpressionBuilder = "";
      this.indicatorType = "";
      this.$nextTick(() => {
        this.goTo('indicatorAdd');
      })
    },
    deleteind(id) {
      Swal.fire({
        text: "Are you sure?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonColor: "#d33",
      }).then((result) => {
        // console.log(result);
        if (result.value) {
          ApiServices.RestDeleteCall("api/indicators/" + id).then((res) => {
            // console.log(res);
            if (res.status == "OK") {
              alert("Indicator deleted succesfully");
            }
          });
        }
      });
    },
    editind(id) {
      this.showIndForm = true;
      ApiServices.RestGetCall(
        "api/indicators/" +
          id +
          "?fields=%3Aall%2CattributeValues%5B%3Aall%2Cattribute%5Bid%2Cname%2CdisplayName%5D%5D"
      ).then((res) => {
        // console.log(res);
        this.frmModel = res;
        // console.log(this.frmModel);
        this.expressionBuilderHidden = this.frmModel.numerator;
        this.denomExpressionBuilderHidden = this.frmModel.denominator;
        // this.expressionBuilder = this.getEquestion(this.frmModel.numerator);
        // this.denomExpressionBuilder = this.getEquestion(
        //   this.frmModel.denominator
        // );
        this.indicatorType = this.frmModel.indicatorType.id;
      });
      ApiServices.RestGetCall(
        "api/indicatorTypes?fields=id%2CdisplayName%2Cname&paging=false"
      ).then((res) => {
        // console.log(res);
        this.indicatorTypes = res.indicatorTypes;
      });
    },
    getEquestion(expression) {
      var newexp = expression;
      this.dataElementList.forEach((obj) => {
        if (expression.search("#{" + obj.id + "}") != -1) {
          newexp = newexp.replace("#{" + obj.id + "}", obj.displayName);
        }
      });
      return newexp;
    },

    updateInd() {
      this.frmModel.numerator = this.expressionBuilderHidden;
      this.frmModel.denominator = this.denomExpressionBuilderHidden;
      var formData = this.frmModel;
      // console.log(formData);
      ApiServices.RestPutCall(
        "/api/indicators/" + formData.id + "?mergeMode=REPLACE",
        formData
      ).then((res) => {
        // console.log(res);
        if (res.httpStatusCode == 200) {
          this.frmModel = {
            denominatorDescription: "",
            numeratorDescription: "",
            numerator: "",
            denominator: "",
            name: "",
            shortName: "",
            indicatorType: {},
            legendSets: [],
          };
          this.expressionBuilderHidden = "";
          this.denomExpressionBuilderHidden = "";
          this.expressionBuilder = "";
          this.denomExpressionBuilder = "";
          this.indicatorType = "";
          this.showIndForm = false;
          Swal.fire({
            text: "Indicator updated successfully",
            //  icon: 'warning',
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then(function () {
            window.location = "#/indicatorAdd";
          });
        }
      });
    },
    submitInd() {
      this.frmModel.numerator = this.expressionBuilderHidden;
      this.frmModel.indicatorType = { id: this.indicatorType };
      this.frmModel.denominator = this.denomExpressionBuilderHidden;
      var formData = this.frmModel;
      ApiServices.RestPostCall("api/indicators", formData).then((res) => {
        // console.log(res);
        if (res.httpStatusCode == 201) {
          this.frmModel = {
            denominatorDescription: "",
            numeratorDescription: "",
            numerator: "",
            denominator: "",
            name: "",
            shortName: "",
            indicatorType: {},
            legendSets: [],
          };
          this.expressionBuilderHidden = "";
          this.denomExpressionBuilderHidden = "";
          this.expressionBuilder = "";
          this.denomExpressionBuilder = "";
          this.indicatorType = "";
          this.showIndForm = false;
          Swal.fire({
            text: "Indicator created successfully",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then(function () {
            window.location = "#/indicatorAdd";
          });
        } else {
          Swal.fire({
            text: "Something went wrong. Please try again",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then(function () {
            window.location = "#/indicatorAdd";
          });
        }
      });
    },
    addElem(elemId, elemName, typeSt = null) {
      this.expressionBuilder = this.expressionBuilder + elemName;
      if (typeSt == "DataElem") {
        this.expressionBuilderHidden =
          this.expressionBuilderHidden + "#{" + elemId + "}";
      } else {
        this.expressionBuilderHidden = this.expressionBuilderHidden + elemId;
      }
    },
    addElemDenom(elemId, elemName, typeSt = null) {
      this.denomExpressionBuilder = this.denomExpressionBuilder + elemName;
      if (typeSt == "DataElem") {
        this.denomExpressionBuilderHidden =
          this.denomExpressionBuilderHidden + "#{" + elemId + "}";
      } else {
        this.denomExpressionBuilderHidden =
          this.denomExpressionBuilderHidden + elemId;
      }
    },
    goTo(refName) {
      let element = this.$refs[refName];
      console.log(element)
      if(element) {
        let top = element.offsetTop;
        console.log(top)

        window.scrollTo(0, top);
      }
    },
    gotoApp(appId, appUserId) {
      window.open(
        `http://localhost:8080/#/?appId=${appId}&appUserId=${appUserId}`,
        "_blank"
      );
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action",
        {}
      ).then((res) => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    getList() {
      ApiServices.RestGetCall(
        "api/dataElementOperands?filter=dataElement.domainType:eq:AGGREGATE&fields=id%2CdisplayName&totals=true",
        {}
      ).then((res) => {
        // console.log(res);
        if (res.dataElementOperands != undefined)
          this.dataElementList = res.dataElementOperands;
        this.denomdataElemenList = res.dataElementOperands;
      });
      ApiServices.RestGetCall(
        "api/indicatorTypes?fields=id%2CdisplayName%2Cname&paging=false"
      ).then((res) => {
        // console.log(res);
        this.indicatorTypes = res.indicatorTypes;
      });
    },
    getAllApps() {
      console.log(this.$root);
      this.$root.loading = true;
      ApiServices.getAllKeys()
        .then(async (response) => {
          console.log(response);
          let filteredApps = [];

          response.data.forEach((a) => {
            let keyName = a.split("_");
            if (a.includes("applicationModule") && keyName.includes("en")) {
              filteredApps.push(a);
            }
          });

          await ApiServices.RestGetCall(
            "/api/avenir/training/getTrainingApps"
          ).then((response) => {
            console.log("Training response", response.trainingApp);
            response.trainingApp.forEach((t) => {
              this.allAppsList.push(t);
            });
          });
          if (filteredApps.length) {
            filteredApps.forEach(async (f, i) => {
              let appResponse = await ApiServices.getSavedConfig(f);
              this.allAppsList.push(appResponse.data);
              if (this.allAppsList.length === filteredApps.length) {
                this.$root.loading = false;
                console.log("apps List", this.allAppsList);
              }
            });
          }
        })
        .catch((res) => (this.$root.loading = false));
    },
    getIndicatorList() {
      ApiServices.RestGetCall(
        "api/indicators?filter=name:ne:default&fields=name%2CnumeratorDescription%2CdenominatorDescription%2Cdenominator%2Cnumerator%2CdisplayName%2CshortName%2Cid%2ClastUpdated%2Ccreated%2CdisplayDescription%2Ccode%2CpublicAccess%2Caccess%2Chref%2Clevel%2CdisplayName%2CindicatorType%5BdisplayName%5D%2CpublicAccess%2ClastUpdated%2C&order=displayName%3AASC&paging=false"
      ).then((response) => {
        // console.log(response);
        this.allIndList = response.indicators;
        this.$root.loading = false
      }).catch(() => this.$root.loading = false)
    },
  },
  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    //this.getAllApps();
    this.$root.loading = true
    this.getIndicatorList();
    this.getList();
  },
};
</script>
<style scoped lang="scss">
.mainWrap-bg {
  background-color: #f4f4f4 !important;
  background-image: none;
  /* background-size: cover;
  background-position: center; */
  min-height: 100vh;
  /* padding: 20px 40px; */
  padding: 10px 20px;
}
.maindivWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.form-control {
  background-color: transparent !important;
}
.tableCard {
  .table {
    thead {
      tr {
        background: #2e3f53;
        th {
          color: #fff;
        }
      }
    }
  }
}
.addIndicatorTypebtn {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn:hover {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn::after {
  position: absolute;
  right: 15px;
  top: 15px;
}
.multiSelectOption option {
  font-size: 0.75rem;
  background: #f5f5f5;
  padding: 10px 12px;
  margin-bottom: 1%;
  white-space: initial;
  min-height: 2.5em;
  font-family: "Montserrat-Regular";
}
.swipTextWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.checkValid {
  text-align: left;
  width: 100%;
  position: relative;
  bottom: -57px;
  font-weight: 600;
}
textarea {
  width: 100%;
  height: 200px !important;
}
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  // height: 2.375rem;
  // line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}
table tbody {
  border-radius: 0px 0px 10px 10px;
}
table tbody tr:last-child td:nth-last-child(1) {
  border-radius: 0px 0px 10px 0px;
}
table tbody tr:last-child td:nth-last-child(4) {
  border-radius: 0px 0px 0px 10px;
}
</style>
